import { action } from 'typesafe-actions';

import { CityAutoComplete } from 'models/cityAutoComplete';

export const CITIES_AUTO_COMPLETE_REQUEST = 'CITIES_AUTOCOMPLETE_REQUEST';
export const CITIES_AUTO_COMPLETE_SUCCESSFUL = 'CITIES_AUTOCOMPLETE_SUCCESSFUL';
export const CITIES_AUTO_COMPLETE_FAILURE = 'CITIES_AUTOCOMPLETE_FAILURE';

export const citiesAutoCompleteRequest = () => action(CITIES_AUTO_COMPLETE_REQUEST);

export const citiesAutoCompleteSuccessful = (cities: CityAutoComplete[]) => action(CITIES_AUTO_COMPLETE_SUCCESSFUL, cities);

export const citiesAutoCompleteError = (error: string) => action(CITIES_AUTO_COMPLETE_FAILURE, error);
